import { CSSProperties } from 'react';
import { antGrey } from './globalStyles';

const styles = {
    innerContent: {
        paddingTop: 12,
        paddingBottom: 89,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: '100%',
        minWidth: 600,
    } as CSSProperties,
    spaceBetween: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
    } as CSSProperties,
    contentSubField: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
    } as CSSProperties,
    stepContentStatusText: {
        lineHeight: 1,
        fontSize: 30,
        fontWeight: 600,
    } as CSSProperties,
    itemMetadata: {
        marginLeft: 12,
    } as CSSProperties,
    inputStyle: {
        maxWidth: 300,
        minWidth: 180,
    } as CSSProperties,
    tableSectionStyle: {
        marginTop: 24,
        display: 'flex',
    } as CSSProperties,
    featureReadinessSectionHeader: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
    } as CSSProperties,
    contentWithFooterStyle: {
        marginBottom: 59,
    } as CSSProperties,
    footerStyle: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 2,
        backgroundColor: antGrey.grey4,
        minHeight: 59,
        borderTopColor: antGrey.grey5,
        borderTopStyle: 'solid',
        borderTopWidth: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 12,
        paddingBottom: 12,
        overflow: 'hidden',
    } as CSSProperties,
    featureItemDescriptionStyle: {
        display: 'inline-block',
        verticalAlign: 'middle',
        minWidth: 180,
    } as CSSProperties,
    featureItemParagraphStyle: {
        marginBottom: 0,
        color: antGrey.grey8,
    } as CSSProperties,
    featureItemDescriptionTooltipOverlayStyle: {
        maxWidth: 700,
    } as CSSProperties,
    screenshotsLocalizationContentWrapper: {
        backgroundColor: antGrey.grey2,
    } as CSSProperties,
};

export default styles;
